import { render } from "./TextFormV2.vue?vue&type=template&id=20ff37d6&scoped=true"
import script from "./TextFormV2.vue?vue&type=script&lang=js"
export * from "./TextFormV2.vue?vue&type=script&lang=js"

import "./TextFormV2.vue?vue&type=style&index=0&id=20ff37d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ff37d6"]])

export default __exports__